import { InfluencerProfileAudience, InfluencerProfileAudienceProps } from '../shared';

type InfluencerYoutubeProfileAudienceProps = InfluencerProfileAudienceProps;

export const InfluencerYoutubeProfileAudience = (props: InfluencerYoutubeProfileAudienceProps) => (
  <InfluencerProfileAudience {...props} />
);
